import * as React from 'react';
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from 'react-icons/md';
import {
  Button, CheckBox, ComboBox, ComboBoxModel, DateTextBox, FlexLayout, SearchLayout, TableLayout, TextBox,
} from '../../../../components';
import {
  Global,
  TemplateProps,
} from '../../../../constants';
import { Format } from '../../../../utils/string';
import { Date6Calculator, Date8 } from '../../../../utils/time';
import { PrepaymentBundle } from './PrepaymentBundle';

const mijflags = [
  { value: '0', remark: '미지급' },
  { value: '1', remark: '매입' },
  { value: '2', remark: '지급' },
];

/**
 * 화면
 * @window w_tb_pb300_05
 * @category 급여일괄전송[출력/메일]
 */
export const PrepaymentBundleTemplate: React.FC<TemplateProps<PrepaymentBundle>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <SearchLayout size={Global.LAYOUT_SEARCH_HEIGHT_1}>
      <FlexLayout size={300}>
        <span>월</span>
        <DateTextBox
          value={scope.state.yearmon}
          textAlign="center"
          format="####년 ##월"
          onChange={(value) => {
            scope.setState({ yearmon: value },
              () => scope.onRetrieveEvent());
          }}
          onEnter={() => scope.onRetrieveEvent()}
          head={(<button
            onClick={() => {
              scope.setState({ yearmon: new Date6Calculator(scope.state.yearmon).add(-1).toString() },
                () => scope.onRetrieveEvent());
            }}
          >
            <MdKeyboardArrowLeft size={24}/>
          </button>)}
          trail={(<button
            onClick={() => {
              scope.setState({ yearmon: new Date6Calculator(scope.state.yearmon).add().toString() },
                () => scope.onRetrieveEvent());
            }}
          >
            <MdKeyboardArrowRight size={24}/>
          </button>)}
          isDisabledTrackingStateChange={true}
        elField="yearmon"
        />
      </FlexLayout>

      <FlexLayout size={250}>
        <span>사업장</span>
        <ComboBox
          value={scope.state.spjangcd}
          textAlign="center"
          data={scope.props.publicStore.spjangs.map((x) => new ComboBoxModel(x.spjangcd, x.spjangnm))}
          onSelect={(option) => scope.setState({ spjangcd: option.value },
            () => scope.onRetrieveEvent())}
          isDisabledTrackingStateChange={true}
        elField="spjangcd"
        />
      </FlexLayout>

      <FlexLayout size={250}>
        <span>임원구분</span>
        <ComboBox
          value={scope.state.offiyn}
          textAlign="center"
          data={[
            { value: '%', remark: '전체' },
            { value: '1', remark: '임원' },
            { value: '0', remark: '직원' },
          ].map((x) => new ComboBoxModel(x.value, x.remark))}
          onSelect={(option) => scope.setState({ offiyn: option.value },
            () => scope.onRetrieveEvent())}
          isDisabledTrackingStateChange={true}
        elField="offiyn"
        />
      </FlexLayout>
      <FlexLayout size = {300}>
        <span>사원명</span>
        <TextBox
          placeholderColor="#CACACA"
          placeholderAlign="left"
          placeholder="사원명으로 입력하세요."
          value={scope.state.as_nm}
          onChange={(value) => scope.setState({ as_nm: value })}
          onEnter={() => scope.onRetrieveEvent()}
          isDisabledTrackingStateChange={true}
        elField="as_nm"
        />
      </FlexLayout>
      <FlexLayout/>

      {scope.state.userData === 'dmyong_g'
        ? < Button
        onClick={() => scope.onButtonEmail()}
        >
        EMAIL
        </Button>
        : ''
      }
      <Button
        onClick={() => scope.onButtonExcel()}
      >
        대량이체파일생성
      </Button>
    </SearchLayout>

    <FlexLayout>
      <TableLayout
        ref={scope.table}
        header={[
          {
            id: 'chk',
            text: (
              <FlexLayout
                justify="center"
                align="center"
              >
                <CheckBox
                  noMargin
                  value={scope.state.pushTotalCheck}
                  onChange={async (value) => scope
                    .updateCheckAllToggle(value)}
                  isDisabledTrackingStateChange={true}
                />
              </FlexLayout>
            ),
            width: 3,
            render: (x, rowUpdate) => (
              <FlexLayout
                justify="center"
                align="center"
              >
                <CheckBox
                  noMargin
                  value={x.chk === '1'}
                  onChange={(value) => {
                    rowUpdate({ chk: value ? '1' : '0' });
                  }}
                  isDisabledTrackingStateChange={true}
                />
              </FlexLayout>
            ),
          },
          {
            id: 'prtflag',
            text: '출력',
            width: 5,
            render: (x) => (
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: x.prtflag === '0' ? 'var(--color-red)' : 'var(--color-blue)' }}
              >
                {x.prtflag === '1' ? '출력' : '미출력'}
              </FlexLayout>
            ),
          },
          {
            id: 'emailflag',
            text: '메일전송',
            width: 6,
            render: (x) => (
              <FlexLayout
                justify="center"
                align="center"
                style={{ color: x.emailflag === '0' ? 'var(--color-red)' : 'var(--color-blue)' }}
              >
                {x.emailflag === '0' ? '미전송' : '전송'}
              </FlexLayout>
            ),
          },
          {
            id: 'no',
            text: '순번',
            width: 4,
          },
          {
            id: 'entdate',
            text: (
              <FlexLayout isVertical={true}>
                <FlexLayout
                  align="start"
                  style={{ color: 'var(--color-blue)' }}
                >
                  입사일
                </FlexLayout>
                <FlexLayout
                  align="center"
                  style={{ color: 'var(--color-red)' }}
                >
                  퇴사일
                </FlexLayout>
              </FlexLayout>
            ),
            width: 7,
            render: (x) => (
              <FlexLayout isVertical={true}>
                <FlexLayout
                  justify="center"
                  align="center"
                >
                  {Date8.withDash(x.entdate)}
                </FlexLayout>
                <FlexLayout
                  justify="center"
                  align="center"
                  style={{ color: 'var(--color-red)' }}
                >
                  {x.rtdate === null ? '' : Date8.withDash(x.rtdate)}
                </FlexLayout>
              </FlexLayout>
            ),
          },
          {
            id: 'rspnm',
            text: '직책',
            width: 6,
          },
          {
            id: 'pernm',
            text: '성명',
            width: 6,
          },
          {
            id: 'email',
            text: '메일주소',
            width: 10,
            trail: () => (
              <FlexLayout
                justify="right"
                align="center"
              >
                연간 연봉총액 정산내역
              </FlexLayout>
            ),
            render: (x) => (
              <FlexLayout
                justify="left"
                align="center"
              >
                {x.email}
              </FlexLayout>
            ),
          },
          {
            id: 'tot_samt',
            text: '월간급여총액',
            width: 7,
            trail: () => (
              <FlexLayout
                justify="right"
                align="center"
              >
                {scope.state.tot_samt_tot}
              </FlexLayout>
            ),
            render: (x) => (
              <FlexLayout
                justify="right"
                align="center"
              >
                {Format.number(x.tot_samt)}
              </FlexLayout>
            ),
          },
          {
            id: 'tot_tamt',
            text: '공제내역총액',
            width: 7,
            trail: () => (
              <FlexLayout
                justify="right"
                align="center"
                style={{ color: 'var(--color-red)' }}
              >
                {scope.state.tot_tamt_tot}
              </FlexLayout>
            ),
            render: (x) => (
              <FlexLayout
                justify="right"
                align="center"
                style={{ color: 'var(--color-red)' }}
              >
                {Format.number(x.tot_tamt)}
              </FlexLayout>
            ),
          },
          {
            id: 'tot_mamt',
            text: '실수령액',
            width: 7,
            trail: () => (
              <FlexLayout
                justify="right"
                align="center"
                style={{ color: 'var(--color-blue)' }}
              >
                {scope.state.tot_mamt_tot}
              </FlexLayout>
            ),
            render: (x) => (
              <FlexLayout
                justify="right"
                align="center"
                style={{ color: 'var(--color-blue)' }}
              >
                {Format.number(x.tot_mamt)}
              </FlexLayout>
            ),
          },
          {
            id: 'mijflag',
            text: '지급구분',
            width: 6,
            render: (x) => (
              <FlexLayout
                justify="center"
                align="center"
                style={{
                  // eslint-disable-next-line no-nested-ternary
                  color: x.mijflag === '0'
                    ? 'var(--color-red)'
                    : x.mijflag === '2'
                      ? 'var(--color-blue)'
                      : '#7F7A2C',
                }}
              >
                {mijflags.filter((y) => y.value === x.mijflag)[0]?.remark}
              </FlexLayout>
            ),
          },
          {
            id: 'banknm',
            text: '지급은행',
            width: 6,
            render: (x) => (
              <FlexLayout
                justify="center"
                align="center"
              >
                {x.banknm}
              </FlexLayout>
            ),
          },
          {
            id: 'accnum',
            text: '계좌번호',
            width: 8,
            render: (x) => (
              <FlexLayout
                justify="left"
                align="center"
              >
                {x.accnum}
              </FlexLayout>
            ),
          },
          {
            id: 'title',
            text: '비고',
            width: 12,
            render: (x) => (
              <FlexLayout
                justify="left"
                align="center"
              >
                {x.title}
              </FlexLayout>
            ),
          },
        ]}
        data={scope.state.data}
        infinityHandler={scope.infinity}
        rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
        onChange={(rows, updatedRows) => {
          scope.onUpdatedRows(rows, updatedRows);
        }}
        onRowFocusEvent={(item) => scope.onRowFocusEvent(item)}
      elGrid="data"
      />
    </FlexLayout>
  </FlexLayout>
);
